import {ActionReducer, ActionReducerMap, MetaReducer} from '@ngrx/store';
import {environment} from '../../../environments/environment';
import {AppState} from '../states/app.state';
import {initialJfLibState, jfLibReducers, withLastVisitedRoute} from '@adnova/jf-ng-components';
import {appNavigationStateInitial} from '../../modules/pages/app-navigation/+store/app-navigation.state.initial';
import {appNavigationReducer} from '../../modules/pages/app-navigation/+store/app-navigation.reducer';
import {newsEntitiesStateInitial, newsEntitiesReducer} from './news-entities.reducers';
import {newsStateInitial} from '../../modules/routes/news/+store/news.state.initial';
import {newsReducer} from '../../modules/routes/news/+store/news.reducer';
import {newsArticleStateInitial} from '../../modules/routes/news-article/+store/news-article.state.initial';
import {newsArticleReducer} from '../../modules/routes/news-article/+store/news-article.reducer';
import {overviewStateInitial} from '../../modules/routes/overview/+store/overview.state.initial';
import {overviewReducer} from '../../modules/routes/overview/+store/overview.reducer';
import {UserViewConfigState} from '../states/user-view-config.state';
import {userViewConfigInitial, userViewConfigReducer} from './user-view-config.reducers';


export const initialAppState: AppState = {
  ...initialJfLibState,
  appNavigation: appNavigationStateInitial,
  newsEntities: newsEntitiesStateInitial,
  news: newsStateInitial,
  newsArticle: newsArticleStateInitial,
  overview: overviewStateInitial,
  userViewConfig: userViewConfigInitial,
};

export const reducers: ActionReducerMap<AppState> = {
  ...jfLibReducers,
  appNavigation: appNavigationReducer,
  newsEntities: newsEntitiesReducer,
  news: newsReducer,
  newsArticle: newsArticleReducer,
  overview: overviewReducer,
  userViewConfig: userViewConfigReducer,
};

export function logger(reducer: ActionReducer<any>): ActionReducer<any> {
  return (state, action) => {
    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [logger] : [];
metaReducers.push(withLastVisitedRoute);
